import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Marquee from "../components/Marquee";
import { about } from "../mock/mock";

const About = () => {
  return (
    <div>
      <section className="bg-[#FFF6F9] py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <span className="font-body text-xs tracking-[0.35em] uppercase text-[#9D184C]">Rim Patisse</span>
          <h1 className="font-title text-3xl md:text-5xl text-[#3A2A30] mt-4">{about.title}</h1>
          <div className="w-16 h-[3px] bg-[#9D184C] rounded-full mx-auto mt-6" />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative fade-up">
            <div className="aspect-[4/5] rounded-[28px] overflow-hidden shadow-[0_20px_50px_rgba(157,24,76,0.18)]">
              <img src={about.image} alt="Rim, pâtissière" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="fade-up" style={{ animationDelay: "120ms" }}>
            {about.paragraphs.slice(0, 3).map((p, i) => (
              <p key={i} className="font-body text-[#3A2A30]/75 leading-relaxed mb-4">{p}</p>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 md:gap-8 mt-16 max-w-3xl mx-auto">
          {about.stats.map((s, i) => (
            <div key={i} className="text-center bg-[#FFF6F9] rounded-2xl py-8 px-4 border border-[#F3D9E2]">
              <div className="font-title text-3xl md:text-4xl text-[#9D184C]">{s.value}</div>
              <div className="font-body text-xs md:text-sm text-[#3A2A30]/60 mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <Marquee />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="order-2 md:order-1">
            {about.paragraphs.slice(3).map((p, i) => (
              <p key={i} className="font-body text-[#3A2A30]/75 leading-relaxed mb-4">{p}</p>
            ))}
            <Link to="/devis" className="inline-flex items-center gap-2 font-body text-sm uppercase tracking-wide bg-[#9D184C] hover:bg-[#7A0F39] text-white px-8 py-4 rounded-full transition-colors duration-200 mt-4">
              Créons ensemble <ArrowRight size={18} />
            </Link>
          </div>
          <div className="order-1 md:order-2">
            <div className="aspect-[4/3] rounded-[28px] overflow-hidden shadow-[0_20px_50px_rgba(157,24,76,0.18)]">
              <img src={about.image2} alt="Création Rim'pâtisse" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
